/**
 * Testimonial module
 *
 * Blockquote with source and a rounded image
 */

// Deps
import { FelaComponent, createComponent } from "react-fela";
import { gutters, colors } from "~/styleguide";
import { fluid } from "~/styleguide/utils";
import { textStyles } from "~/styleguide/typography";

// Components
import WordpressLink, {
    getLinkFromRelationship
} from "~/components/global/links";
import CardListing from "~/components/resource/listing/card";
import { ContentMaxWidth } from "~/components/layout/max-width";

export default function RelatedResources({ block }) {
    const {
        heading,
        link,
        link_label,
        link_type,
        link_content,
        resources,
        use_grey_background,
        anchor_id
    } = block;

    const parsedLink = getLinkFromRelationship(link_type, link_content, link);
    return (
        <Container id={anchor_id} greyBG={use_grey_background} className="module-related-resources">
            <ContentMaxWidth>
                <Content>
                    {/* Heading */}
                    {heading && (
                        <FelaComponent as="h3" style={textStyles.heading3}>
                            <span dangerouslySetInnerHTML={{ __html: heading }} />
                        </FelaComponent>
                    )}

                    {/* Link Out */}
                    {parsedLink && parsedLink.url && link_label && (
                        <WordpressLink
                            extend={readMoreStyles}
                            url={parsedLink.url}
                            slug={parsedLink.slug}
                            label={link_label + " "}
                            layout="text"
                        />
                    )}
                </Content>

                {/* Card Listing */}
                <RelatedOuter>
                    <RelatedInner length={resources.length}>
                        <CardListing
                            extend={cardListingStyles}
                            resources={resources}
                            layout="carousel"
                            eyebrow="type"
                        />
                    </RelatedInner>
                </RelatedOuter>
            </ContentMaxWidth>
        </Container>
    );
}

const readMoreStyles = {
    margin: "20px 0px 0px 0px",
    fontWeight: "bold",
    display: "inline-block",
    extend: [fluid("font-size", { max: 24, min: 18 })]
};

const cardListingStyles = {
    extend: [fluid("marginTop", { min: 20, max: 50 })]
};

const Container = createComponent(
    ({ greyBG }) => ({
        extend: [
            {
                condition: greyBG,
                style: {
                    background: colors.lightGrey
                }
            },
            fluid("paddingV", gutters.vertical)
        ],

        minWidthTabletLandscape: {
            extend: [fluid("paddingH", gutters.default)]
        }
    }),
    "div",
    ["id"]
);

const Content = createComponent(() => ({
    textAlign: "center",

    maxWidthTabletLandscape: {
        extend: [fluid("paddingH", gutters.default)]
    }
}));

const RelatedOuter = createComponent({
    maxWidthTabletLandscape: {
        width: "100%",
        overflowX: "scroll",
        overflowScrolling: "touch"
    }
});

const RelatedInner = createComponent(({ length }) => ({
    maxWidthTabletLandscape: {
        width: 280 * length + 20 * (length - 1) + 10,
        paddingLeft: 5
    }
}));
